import { usePrivacyMask } from "@nimit9/signet-ui/components/privacy-mask"
import { useCurrencyFormat } from "@/hooks/use-currency-format"
import { cn } from "@/lib/cn"

interface AmountProps {
  value: number | string
  className?: string
  showSign?: boolean
  precise?: boolean
}

export function Amount({ value, className, showSign = false, precise = false }: AmountProps) {
  const fmt = useCurrencyFormat()
  const { masked } = usePrivacyMask()
  const num = typeof value === "string" ? parseFloat(value) : value
  const isNegative = num < 0
  const isPositive = num > 0

  if (masked) {
    // PAISA-PRIV-01: a fixed-width placeholder. No sign, no credit/debit
    // colour and nothing in title/aria — the real value never reaches the DOM.
    return (
      <span
        data-masked="true"
        role="img"
        aria-label="Amount hidden"
        className={cn("font-mono tabular-nums text-text-muted", className)}
      >
        {fmt(0)}
      </span>
    )
  }

  return (
    <span
      className={cn(
        // PAISA-AMT-02: sign carries direction, colour carries state — debits
        // stay neutral ink, only credits get the accent. Red is reserved for
        // destructive actions, not routine spending.
        "font-mono tabular-nums",
        isNegative && "text-money-debit",
        isPositive && showSign && "text-money-credit",
        className,
      )}
    >
      {showSign && isPositive && "+"}
      {fmt(num, precise)}
    </span>
  )
}
